const kz = {
  action: {
    subscribe: 'Қосу',
    rule: 'Біздің жеңімпаздарымыз',
    close: 'Жақсы',
    wantTheSame: 'Мен де қалаймын'
  },
  town: {
    almaty: 'Алматы',
    astana: 'Астана',
    karaganda: 'Қарағанды',
    atyrau: 'Атырау',
    uralsk : 'Орал',
    kordaiDistrict: 'Қордай ауданы'
  },
  menu: {
    participate: 'Лотереяға қатысу',
    prizes: 'Жүлделер',
    rules: 'Лотерея ережелері',
    feedback: 'Кері байланыс',
    hotLineDesktop: 'Сенім телефоны <a href="tel:88000809351" target="_blank" rel="noreferrer">8-800-080-9351</a>',
    hotLineMobile: 'Толық ақпарат алу үшін немесе туындаған мәселені шешу үшін <a href="tel:88000809351" target="_blank" rel="noreferrer">8-800-080-9351</a> тегін нөміріне қоңырау шалыңыз.'
  },
  label: {
    logo: 'Национальная лотерея',
    win: 'жүлде'
  },
  common: {
    title: 'Национальная лотерея'
  },
  promo: {
    title: 'Жазылым лотереясынан 1 000 000₸ ұтып алыңыз',
    desc: [
      'Күніне 100 теңгеге жазылыңыз және күн сайын ақшалай сыйлықтар ұтып алыңыз!',
      'Абоненттерге арналған жедел лотерея <br/><strong>Tele2/Altel</strong>, <strong>Kcell/activ</strong> және <strong>Beeline</strong>'
    ]
  },
  about: {
    title: [
      'Tele2/Altel абоненттеріне арналған «Сенің сәттілігің» лездік лотереясы!',
      'Kcell/Activ абоненттері үшін «OGO Udacha» лездік лотереясы!',
      '«Сәттілік» лездік лотереясы Beeline абоненттері үшін!'
    ],
    list: [
      'Супер жүлде 1 000 000 ₸<br/>Егер сіз ұтып алсаңыз, ұтысты аудару үшін сізбен өзіміз хабарласамыз',
      'Абоненттік шотқа жедел аударумен миллиондаған ақшалай сыйлықтар',
      'Әр билеттің құны 100₸, билет күн сайын SMS арқылы келеді',
      'Билет бірден ойналады, сіз ұтыс ойынының нәтижесін бірден білесіз'
    ]
  },
  prizeFond: {
    title: [
      '«СЕНІҢ СӘТТІЛІГІҢ» лотереяысының жүлде қоры',
      '«OGO Сәттілік» лотереяысының жүлде қоры',
      '«Сәттілік» лотереясының жүлде қоры'
    ],
    label: {
      superPrize: 'Супер жүлде',
      superPrizeCount: '3 супер-жүлде'
    }
  },
  winners: {
    title: 'Біздің жеңімпаздарымыз'
  },
  modal: {
    subscribe: {
      title: 'Миллион ұтыңыз',
      desc: [
        'Сіздің өтінішіңіз қабылданды. Лотереяға жазылу, лотерея билеттері және ұтыс туралы ақпарат туралы мәліметтерді SMS арқылы күтіңіз.'
      ]
    },
    error: {
      title: 'Қосылу қате',
      desc: 'Лотереяға жазылымды қосу кезінде қате пайда болды. Кейінірек қайталыңыз.',
      button: 'Жабу'
    },
    info: {
      title: 'Лотереяға қатысыңыз',
      desc: [
        'Күн сайын SMS арқылы лотерея билеттерін алыңыз және миллион ұтуға тырысып көріңіз!',
        'Tele2/Altel, KCell/Activ және Beeline абоненттеріне арналған лотереяға қатысу үшін сізде жазылым болуы керек, құны 100 ₸/күн..',
        'Жазылымды қосу үшін ұялы телефонда <a href="tel:*88#"><b>*88#</b></a> USSD теріңіз.',
        'Тағы бір немесе бірнеше билет сатып алу үшін, <a href="tel:*88*N#"><b>*88*N#</b></a> командасын теріңіз, мұндағы N - 1-ден 10-ға дейінгі билеттер саны. Мысалы, 10 билет сатып алу үшін, <a href="tel:*88*10#"><b>*88*10#</b></a> командасын теріңіз. Сатып алынған әр билеттің құны 100 ₸.',
        'Нақты ақпарат алу немесе туындаған мәселені шешу үшін <a href="tel: 88000809351"><b class="no-wrap">8-800-080-9351</b></a> тегін нөміріне соғыңыз.'
      ]
    }
  },
  footer: {
    company: `${new Date().getFullYear()} ©  «Сәтті Жұлдыз» АҚ`,
    feedback: 'Кері байланыс',
    terms: 'Пайдалану шарттары',
    socialHeader: 'ӘЛЕУМЕТТІК ЖАУАПКЕРШІЛІК:',
    socialDesc: 'Операциялық ойыннан түскен табыстың 10% отандық спортты дамытуға аударылады. Операциялық ойыннан түскен табыстың 10% «Қазақстан халқына» қоғамдық қорына аударылады.'
  }
};

export default kz;
